var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 19.9219C15.4102 19.9219 19.9219 15.4004 19.9219 9.96094C19.9219 4.51172 15.4199 0 9.9707 0C9.45312 0 9.19922 0.3125 9.19922 0.820312V4.59961C9.19922 5.0293 9.49219 5.36133 9.91211 5.36133C10.3418 5.36133 10.6348 5.0293 10.6348 4.59961V0.800781L9.95117 1.66016C14.5801 1.66016 18.252 5.35156 18.252 9.96094C18.252 14.5703 14.5703 18.2617 9.96094 18.2617C5.35156 18.2617 1.65039 14.5703 1.66016 9.96094C1.66992 7.90039 2.40234 6.03516 3.63281 4.59961C3.92578 4.21875 3.94531 3.75977 3.62305 3.41797C3.30078 3.07617 2.76367 3.10547 2.40234 3.53516C0.917969 5.27344 0 7.5293 0 9.96094C0 15.4004 4.52148 19.9219 9.96094 19.9219Z",
    fill: "#3A78F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96125 11.5337C10.8401 11.5337 11.5433 10.8306 11.5433 9.96141C11.5433 9.4243 11.2796 8.96531 10.8694 8.67235L5.97687 5.21531C5.49836 4.87352 5.00031 5.37156 5.33234 5.86961L8.58429 10.7329C8.89679 11.2114 9.38508 11.5337 9.96125 11.5337Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2832,
    height: 19.9316,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/TimerIcon.90409f39b8f817c13b5d51e8bb8bf334.svg";
export { ForwardRef as ReactComponent };